(() => {
    function loadCSS(url) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = url;
        document.head.appendChild(link);
    }

    function loadJS(url) {
        const script = document.createElement('script');
        script.src = url;
        script.defer = true;
        document.body.appendChild(script);
    }

    function loadAllLazyAssets() {
        if (window._lazyAssetsLoaded) return;
        window._lazyAssetsLoaded = true;

        (window.lazyCSS || []).forEach(loadCSS);
        (window.lazyJS || []).forEach(loadJS);
    }

    ['click', 'scroll', 'mousemove', 'touchstart'].forEach(evt => {
        window.addEventListener(evt, loadAllLazyAssets, { once: true });
    });
})();